import classNames from 'classnames'
import { MdOutlineClear } from 'react-icons/md'

import type { CSSProperties, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  className?: string
  label?: string
  onDelete?: (value: string | number) => void
  outlined?: boolean
  size?: Exclude<SIZES, 'small'>
  style?: CSSProperties
  value: string | number
}

const Badge = ({
  className,
  label,
  onDelete,
  outlined = false,
  size = 'medium',
  style,
  value,
}: Props): ReactElement => {
  const handleDeleteButtonClick = () => {
    onDelete && onDelete(value)
  }

  return (
    <div
      className={classNames('badge-component', className, size, {
        'badge-component--is-number': typeof value === 'number',
        'badge-component--outlined': outlined,
      })}
      style={style}
    >
      {onDelete ? (
        <MdOutlineClear
          className="badge-component__delete-button"
          color="#626262"
          onClick={handleDeleteButtonClick}
          size={14}
        />
      ) : null}
      <span>{label || value}</span>
    </div>
  )
}

export default Badge
